import { render } from "./AppVersion.vue?vue&type=template&id=6276c231&scoped=true&ts=true"
import script from "./AppVersion.vue?vue&type=script&lang=ts"
export * from "./AppVersion.vue?vue&type=script&lang=ts"

import "./AppVersion.vue?vue&type=style&index=0&id=6276c231&scoped=true&lang=css"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6276c231"]])

export default __exports__